import { Point } from 'geojson';

export enum Role {
  NO_ACCESS = -1,
  GOD = 0,
  ADMIN = 1,
  RECRUITER = 2,
  VIEWER = 3,
}

export class Unit {
  id: number;
  name: string;
  parent_id: string;
  parent: Unit;
  children: Unit[];
  logo_url: string;
  logo_media_id: string;
  facebook_url: string;
  linkedin_url: string;
  website_url: string;
  twitter_url: string;
  description_title_rich: string;
  description_rich: string;
  description: string;
  description_image_media_id: number;
  description_image_url: string;
  address: string;
  lon: any;
  lat: any;
  role: Role;
  same_as_parent_address: boolean;
  same_as_parent_logo: boolean;
  same_as_parent_facebook_url: boolean;
  same_as_parent_linkedin_url: boolean;
  same_as_parent_website_url: boolean;
  same_as_parent_description: boolean;
  same_as_parent_twitter_url: boolean;
  point: Point;
  finn_partner: string;
  finn_provider: string;
  tree_id: string;
  root_name: string;

  constructor(props) {
    this.id = props.id;
    this.name = props.name;
    this.parent_id = props.parent_id;
    this.parent = props.parent;
    this.children = props.children;
    this.logo_media_id = props.logo_media_id;
    this.logo_url = props.logo_url;
    this.facebook_url = props.facebook_url;
    this.linkedin_url = props.linkedin_url;
    this.website_url = props.website_url;
    this.children = props.children;
    this.description_image_media_id = props.description_image_media_id;
    this.description_image_url = props.description_image_url;
    this.description_title_rich = props.description_title_rich;
    this.description_rich = props.description_rich;
    this.description = props.description;
    this.address = props.address;
    this.lon = props.lon;
    this.lat = props.lat;
    this.role = props.role;
    this.same_as_parent_logo = props.same_as_parent_logo;
    this.same_as_parent_facebook_url = props.same_as_parent_facebook_url;
    this.same_as_parent_linkedin_url = props.same_as_parent_linkedin_url;
    this.same_as_parent_website_url = props.same_as_parent_website_url;
    this.same_as_parent_description = props.same_as_parent_description;
    this.finn_partner = props.finn_partner;
    this.finn_provider = props.finn_provider;
    this.tree_id = props.tree_id;
    this.root_name = props.root_name;
  }
}
